import { render, staticRenderFns } from "./schema.vue?vue&type=template&id=c5f14902"
import script from "./schema.vue?vue&type=script&lang=js"
export * from "./schema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports